import layoutHeader from './layoutHeader'

export default {
   ...layoutHeader, // User Header as failsafe
   tmpGlobalLayout: 'splash'
}
